import styled from 'styled-components'
import { Popover } from 'react-bootstrap'

export const ContentConfig = styled.div<{ height: number }>`
  width: 100%;
  max-width: 1400px;
  padding: 40px 0 0 0;

  h1.title-config {
    font-size: 1.8rem;
    line-height: 2.2rem;
    color: ${({ theme }) => theme.colors.black};
  }

  .header-config {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
  }

  .button-config {
    background: ${({ theme }) => theme.colors.secondary};
    border: none;
    color: ${({ theme }) => theme.colors.white};
    font-size: 1.4rem;
    font-weight: 600;
    padding: 10px 20px;
    border-radius: 5px;
    cursor: pointer;
  }

  .container-config {
    width: 100%;
    min-height: 200px;
    height: ${({ height }) => height - 180}px;
    border-top: 1px solid ${({ theme }) => theme.colors.gray10};
    border-radius: ${({ theme }) => theme.radius.medium}px;
    margin-top: 10px;

    .calendar-view {
      height: 90%;
      position: relative;

      .fc-header-toolbar {
        margin-bottom: 10px;
        position: relative;

        @media screen and (max-width: 480px) {
          margin-bottom: 25px;
        }
      }

      .fc-scrollgrid {
        margin-top: 110px;

        @media screen and (max-width: 1024px) {
          margin-top: 105px;
        }

        @media screen and (max-width: 768px) {
          margin-top: 95px;
        }

        @media screen and (max-width: 480px) {
          margin-top: 90px;
        }
      }

      .fc-timegrid-event .fc-event-main {
        padding: 0;
      }

      .fc-v-event {
        border-color: ${({ theme }) => theme.colors.secondary};
        background-color: ${({ theme }) => theme.colors.secondaryLight};
        padding: 0;
      }

      .eventContent {
        width: 100%;
        height: 100%;
        padding: 1rem;

        p {
          margin: 0;
          color: ${({ theme }) => theme.colors.secondary};
          text-align: center;
        }
      }

      .fc-bg-event.high-demand-slot {
        background-color: #fcd4c3 !important;
        border: none !important;
        opacity: 1 !important;
        z-index: 0 !important;
        pointer-events: auto !important;
        cursor: pointer;
      }

      .fc-bg-event.high-demand-slot::after {
        content: '';
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%) scale(0);
        width: 28px;
        height: 28px;
        background: linear-gradient(135deg, #d45a20 0%, #e27a41 100%);
        border-radius: 6px;
        opacity: 0;
        transition: all 0.2s ease;
        z-index: 10;
        box-shadow: 0 2px 10px rgba(212, 90, 32, 0.4);
        background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='white'%3E%3Cpath d='M3.5 18.49l6-6.01 4 4L22 6.92l-1.41-1.41-7.09 7.97-4-4L2 16.99z'/%3E%3Cpath d='M21 3h-6v2h2.59l-6.3 6.29 1.42 1.42L19 6.41V9h2V3z'/%3E%3C/svg%3E");
        background-repeat: no-repeat;
        background-position: center;
        background-size: 16px 16px;
      }

      .fc-bg-event.high-demand-slot:hover {
        background-color: #f5b8a3 !important;
      }

      .fc-bg-event.high-demand-slot:hover::after {
        opacity: 1;
        transform: translate(-50%, -50%) scale(1);
      }

      .fc-bg-event.high-demand-slot .fc-event-title {
        display: none !important;
      }

      .fc-timegrid-bg-harness {
        pointer-events: auto !important;
      }

      .fc-timegrid-bg-harness .fc-bg-event.high-demand-slot {
        background-color: #fcd4c3 !important;
        pointer-events: auto !important;
      }

      .fc-timegrid-bg-harness .fc-bg-event.high-demand-slot:hover {
        background-color: #f0a890 !important;
      }
    }
  }

  @media screen and (min-width: 961px) {
    margin: 30px auto;
  }
`

export const PopverContainer = styled(Popover)`
  width: 264px;
  @media screen and (max-width: 600px) {
    position: fixed !important;
    top: 50% !important;
    left: 50% !important;
    transform: translate(-50%, -50%) !important;
    height: 550px !important;
  }

  h3 {
    font-size: 1.2rem;
  }

  .popover {
    &-bordy,
    &-header {
      padding: 12px;
    }

    &-body {
      display: flex;
      align-items: flex-start;
      flex-direction: column;
      padding: 15px;

      h4 {
        font-size: 1.4rem;
      }

      button {
        margin-top: 24px;
      }

      select,
      input {
        width: 100% !important;
        height: 40px !important;
        margin-top: 10px;
        margin-bottom: 10px;
        font-size: 1.4rem;
        line-height: initial;
        padding-left: 10px;
        padding-right: 10px;
        border-radius: 4px;
        border: 1px solid ${({ theme }) => theme.colors.gray20};

        &[type='checkbox'] {
          width: initial !important;
        }
      }

      .form-checkbox {
        .group-checkbox {
          display: flex;
          align-items: center;

          input {
            margin-right: 8px;
          }
        }
      }
    }
  }

  .buttonHighlight {
    width: 100%;
  }

  .button-cancel-schedule {
    width: 100%;
    text-align: center;

    button {
      margin-top: 8px !important;
      background: none;
      border: none;
    }
  }
`

export const EventContent = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  text-align: center;
  align-items: center;
  justify-content: center;

  p {
    margin: 0;
    color: ${({ theme }) => theme.colors.secondary};
    text-align: center;
  }
`

export const InfoBanner = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 8px;
  background-color: #fef3e5;
  border-radius: 16px;
  width: 60%;
  max-width: 100%;
  position: absolute;
  top: 100px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 10;
  align-items: center;
  justify-content: center;
  text-align: center;

  @media screen and (max-width: 1024px) {
    width: 70%;
    top: 100px;
    padding: 14px;
  }

  @media screen and (max-width: 768px) {
    width: 85%;
    top: 95px;
    padding: 12px;
  }

  @media screen and (max-width: 480px) {
    width: calc(100% - 20px);
    top: 90px;
    padding: 12px;
    gap: 6px;
  }
`

export const HighDemandLabel = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  color: #344054;
  font-weight: 600;
  font-size: 1.4rem;
  line-height: 1.6rem;
  text-align: center;
  position: absolute;
  top: 65px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 10;
  width: auto;

  @media screen and (max-width: 1024px) {
    font-size: 1.3rem;
    top: 68px;
    gap: 6px;
  }

  @media screen and (max-width: 768px) {
    font-size: 1.2rem;
    top: 65px;
    gap: 6px;
  }

  @media screen and (max-width: 480px) {
    font-size: 1.1rem;
    top: 63px;
    gap: 5px;
    line-height: 1.4rem;
  }
`

export const DemandDot = styled.span`
  display: inline-block;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background-color: #fcd4c3;
  flex-shrink: 0;

  @media screen and (max-width: 768px) {
    width: 10px;
    height: 10px;
  }

  @media screen and (max-width: 480px) {
    width: 8px;
    height: 8px;
  }
`

export const InfoText = styled.p`
  color: #e27a41;
  font-size: 1.2rem;
  line-height: 1.6rem;
  margin: 0;
  text-align: center;
  white-space: normal;

  @media screen and (max-width: 1024px) {
    font-size: 1.1rem;
    line-height: 1.5rem;
  }

  @media screen and (max-width: 768px) {
    font-size: 1rem;
    line-height: 1.4rem;
  }

  @media screen and (max-width: 480px) {
    font-size: 0.9rem;
    line-height: 1.3rem;
  }
`

export const InfoIconWrapper = styled.span`
  position: relative;
  display: inline-flex;
  align-items: center;
  cursor: pointer;

  &:hover > div {
    visibility: visible;
    opacity: 1;
  }
`

export const InfoIcon = styled.img`
  width: 16px;
  height: 16px;
  flex-shrink: 0;

  @media screen and (max-width: 768px) {
    width: 14px;
    height: 14px;
  }

  @media screen and (max-width: 480px) {
    width: 12px;
    height: 12px;
  }
`

export const Tooltip = styled.div`
  visibility: hidden;
  opacity: 0;
  position: absolute;
  bottom: calc(100% + 10px);
  left: 50%;
  transform: translateX(-50%);
  background-color: #344054;
  color: #ffffff;
  padding: 12px 16px;
  border-radius: 8px;
  font-size: 1.2rem;
  line-height: 1.6rem;
  font-weight: 400;
  white-space: nowrap;
  z-index: 100;
  transition:
    opacity 0.2s ease-in-out,
    visibility 0.2s ease-in-out;
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.15);
  max-width: 300px;
  width: 300px !important;
  white-space: normal;
  text-align: center;

  &::after {
    content: '';
    position: absolute;
    top: 100%;
    left: 50%;
    transform: translateX(-50%);
    border-width: 6px;
    border-style: solid;
    border-color: #344054 transparent transparent transparent;
  }

  @media screen and (max-width: 768px) {
    font-size: 1.1rem;
    line-height: 1.5rem;
    padding: 10px 14px;
    max-width: 250px;
  }

  @media screen and (max-width: 480px) {
    font-size: 1rem;
    line-height: 1.4rem;
    padding: 8px 12px;
    max-width: 200px;
  }
`
